import { h, render } from "preact";

import $ from "jquery";
import Stars from "@/components/ProductRating/ProductRating";
import { getProducts } from "@api/index";
import { onElementsReady } from "@/utils/onElementsReady";
import store from "@store/store";

function extractProductUid(link) {
  const match = link.match(/tproduct\/(?:\d+-)?(\d+)/); // Берем только вторую часть
  return match ? match[1] : link.split("/").pop();
}

const processedUids = new Set();

export function initGlobalSearch() {
  onElementsReady(".t-search-widget__result_product", async () => {
    const items = $(".t-search-widget__result_product")
      .toArray()
      .map((el) => {
        const $el = $(el);
        const productLink = $el
          .find(".t-search-widget__result_product-link")
          .attr("href");
        if (!productLink) return null;

        const uid = extractProductUid(productLink);
        if (processedUids.has(uid)) return null; // ❌ Уже обработан, пропускаем

        processedUids.add(uid);
        return { $el, uid };
      })
      .filter(Boolean);

    if (!items.length) return;

    const uniqueUids = [...new Set(items.map((i) => i.uid))];
    if (!uniqueUids.length) return;

    console.log("📌 Отправляем запрос для UIDs:", uniqueUids);
    try {
      const productsData = await getProducts(uniqueUids);

      store.setState((state) => ({
        products: {
          ...state.products,
          ...Object.fromEntries(productsData.map((p) => [p.uid, p])),
        },
      }));

      items.forEach(({ $el, uid }) => {
        if (!uid || $el.find(".__CC-inject").length) return;

        const $container = $("<div/>", {
          class: "__CC-inject",
          css: { marginBottom: "1px" },
        });

        const $title = $el.find(".t-search-widget__result_product-title");
        if ($title.length) {
          $title.before($container);
        } else {
          $el.prepend($container);
        }

        render(<Stars productUid={uid} />, $container[0]);
      });
    } catch (err) {
      console.error("❌ Ошибка при загрузке рейтингов в глобальном поиске:", err);
    }
  });
}
